import $api from "@/frontend/shared/api/axios";
import { TEmployee } from "../../ui/EditTeamModal/EditTeamModal";

export async function postUpdateEmployeesLatest({ employees }: { employees: any }) {
  const response = await $api.post(`/founder-revisions/employees`, employees);
  return response.data;
}
